import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAdminAuth from './useAdminAuth';

/**
 * 포트빌 호실관리 페이지 접근 권한을 체크하는 커스텀 훅
 */
export const usePortvilleRoomAuth = () => {
  const { loading, user, userLevel, permissions } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      // 인증되지 않은 사용자는 로그인 페이지로 리다이렉트
      if (!user || !userLevel || userLevel > 2) {
        navigate('/admin/signin');
        return;
      }

      // 최고관리자가 아니고 권한이 없는 경우 대시보드로 리다이렉트
      if (userLevel !== 1 && (!permissions || !permissions.portvilleRooms)) {
        navigate('/admin/dashboard');
        return;
      }
    }
  }, [loading, user, userLevel, permissions, navigate]);

  return {
    loading,
    user,
    userLevel,
    permissions,
    hasAccess: !loading && user && userLevel !== null && userLevel <= 2 && 
               (userLevel === 1 || (permissions && permissions.portvilleRooms))
  };
};

export default usePortvilleRoomAuth; 